import React from 'react';
interface Props {
  fillColor?: string;
}
function CataractsIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none">
      <g clipPath="url(#clip0_847_3229)">
        <path
          d="M8.99922 2.5C6.96172 2.5 5.28672 3.425 4.00234 4.61562C2.79922 5.73438 1.96797 7.0625 1.54297 8C1.96797 8.9375 2.79922 10.2656 3.99922 11.3844C5.28672 12.575 6.96172 13.5 8.99922 13.5C11.0367 13.5 12.7117 12.575 13.9961 11.3844C15.1992 10.2656 16.0305 8.9375 16.4555 8C16.0305 7.0625 15.1992 5.73438 13.9992 4.61562C12.7117 3.425 11.0367 2.5 8.99922 2.5ZM2.98047 3.51875C4.45234 2.15 6.47422 1 8.99922 1C11.5242 1 13.5461 2.15 15.018 3.51875C16.4805 4.87812 17.4586 6.5 17.9242 7.61562C18.0273 7.8625 18.0273 8.1375 17.9242 8.38437C17.4586 9.5 16.4805 11.125 15.018 12.4812C13.5461 13.85 11.5242 15 8.99922 15C6.47422 15 4.45234 13.85 2.98047 12.4812C1.51797 11.125 0.539844 9.5 0.0773437 8.38437C-0.0257813 8.1375 -0.0257813 7.8625 0.0773437 7.61562C0.539844 6.5 1.51797 4.875 2.98047 3.51875ZM8.99922 10.5C10.3805 10.5 11.4992 9.38125 11.4992 8C11.4992 6.61875 10.3805 5.5 8.99922 5.5C8.97734 5.5 8.95859 5.5 8.93672 5.5C8.97734 5.65938 8.99922 5.82812 8.99922 6C8.99922 7.10313 8.10234 8 6.99922 8C6.82734 8 6.65859 7.97813 6.49922 7.9375C6.49922 7.95937 6.49922 7.97813 6.49922 8C6.49922 9.38125 7.61797 10.5 8.99922 10.5ZM8.99922 4C10.0601 4 11.0775 4.42143 11.8276 5.17157C12.5778 5.92172 12.9992 6.93913 12.9992 8C12.9992 9.06087 12.5778 10.0783 11.8276 10.8284C11.0775 11.5786 10.0601 12 8.99922 12C7.93835 12 6.92094 11.5786 6.17079 10.8284C5.42065 10.0783 4.99922 9.06087 4.99922 8C4.99922 6.93913 5.42065 5.92172 6.17079 5.17157C6.92094 4.42143 7.93835 4 8.99922 4Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_847_3229">
          <rect width="18" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CataractsIcon;
